import angular from 'angular'

import ActionBarDirective from './vd-action-bar.directive'

angular.module('vend.ui').directive('vdActionBar', ActionBarDirective)
